<template>
	<main style="height: 100%" @click="doCloseMenu">
		<div :class="getMainClasses">
			<transition name="fade">
				<div v-if="isMobile && showSideMenu" class="fade" />
			</transition>
			<Sidemenu
				v-if="(!isMobile || showSideMenu) && !printMode"
				@logout="doLogout"
			/>
			<Navbar
				:style="isMobile ? 'left: 0' : ''"
				v-if="!printMode"
				@logout="doLogout"
				@showDropdown="menuState"
				@openMenu="toggleSideMenu"
				:closeMenu="closeMenu"
			/>
			<CustomerPicker :menu-open="!isCollapsed"/>
			<div
				:class="{
					mobile: isMobile,
					nosidebar: isMobile || printMode,
					nonavbar: printMode
				}"
				class="column is-fullwidth main-block"
			>
				<slot />
			</div>
			<Spinner
				class="loading-spinner"
				:class="{ mobile: isMobile, collapsed: isCollapsed, 'customer-expanded': getCustomerPicker }"
			/>
		</div>
	</main>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import CustomerPicker from '@/components/customer/customer-picker';
import Sidemenu from '@/components/Sidemenu';
import Navbar from '@/components/Navbar';
import Spinner from '@/components/Spinner';

export default {
	components: {
		Sidemenu,
		Navbar,
		Spinner,
		CustomerPicker
	},

	data: () => ({
		loggingIn: false,
		wrongCredentials: false,
		closeMenu: false,
		showSideMenu: false,
		ready: false
	}),

	computed: {
		...mapGetters('appStore', ['isMobile', 'isCollapsed', 'printMode', 'getCustomerPicker']),
		...mapGetters('user', ['getUser', 'getToken', 'getRefreshToken']),

		getMainClasses() {
			return ['columns', 'main-columns', {
				'main-columns--collpased': this.isCollapsed,
				'main-columns--mobile': this.isMobile || this.printMode
			}];
		}
	},

	methods: {
		...mapActions('user', ['logout']),
		...mapActions('appStore', ['setMobileState']),
		...mapMutations('customerStore', { resetCustomerStore: 'RESET' }),
		...mapMutations('companyStore', { resetCompanyStore: 'RESET' }),
		...mapMutations('buildingStore', { resetBuildingStore: 'RESET' }),

		async doLogout() {

			try {
				await this.$services.user.logout({
					token: this.getToken,
					refreshToken: this.getRefreshToken
				});
			} catch(error) {
				console.error(error);
			}


			this.resetCustomerStore();
			this.resetCompanyStore();
			this.resetBuildingStore();
			this.logout();

			this.$router.push(`/${this.$i18n.locale}/login`);
		},

		doCloseMenu() {
			this.closeMenu = true;
			this.showSideMenu = false;
		},

		menuState(state) {
			this.closeMenu = !state;
		},

		toggleSideMenu() {
			this.showSideMenu = !this.showSideMenu;
		}
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/colors.scss";
@import "@/assets/variables.scss";

.fade {
  position: absolute;
  background-color: $background-fade;
  width: 100vw;
  height: 100%;
  z-index: 9;
}

.mobile {
  margin-left: 0;
  width: 99%;
}

.nosidebar {
  margin-left: 0 !important;
}

.nonavbar {
  margin-top: -3rem !important;
}

.loading-spinner {
  position: fixed;
  top: calc(40vh);
  width: calc(100% - 200px);
  z-index: 999;
  display: flex;
  justify-content: space-around;

  &.collapsed {
    width: calc(100% - #{$menu-collapsed-width});
		&.customer-expanded {
			width: calc(100% - 300px - #{$menu-collapsed-width});
			margin-left: 300px;
		}
  }
	
	&.customer-expanded {
		width: calc(100% - 500px);
		margin-left: 300px;
	}

  &.mobile {
    width: 100%;
    margin-left: 0;
  }
}
</style>
